// extracted by mini-css-extract-plugin
export default {"block":"Style_block__eVhG8","subTitle":"Style_subTitle__ddeek","fullWidth":"Style_fullWidth__peOUS","fieldLabel":"Style_fieldLabel__KY5Iu","helper":"Style_helper__crKrF"};